import { COLORS, TYPOGRAPHY } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

export default createStyleSheet({
  wrapper: {
    margin: '24px auto 64px auto',
  },
  section: {
    backgroundColor: COLORS.WHITE.DEFAULT,
    borderRadius: '12px',
    maxWidth: '850px',
    margin: '0 auto 24px auto',
    padding: '24px',
  },
  title: {
    ...TYPOGRAPHY.TITAN_L_SEMIBOLD,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '24px',
    gap: '16px',
  },
  subtitle: {
    marginBottom: '24px',
  },
  infosContainer: {
    display: 'flex',
    gap: '24px',
    marginBottom: '24px',
  },
  infosInputContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  showLongText: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    ...TYPOGRAPHY.BODY2_BOLD,
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  mediaPicker: {
    height: '167px',
    width: '167px',
  },
  inputBackground: {
    backgroundColor: COLORS.WHITE.DEFAULT,
  },
  inputRadius: {
    borderRadius: '8px',
  },
  availablePeriodTitle: {
    paddingTop: '8px',
    marginBottom: '24px',
  },
  datePicker: {
    width: '280px',
    borderRadius: '8px',
  },
  datePickerContainer: {
    display: 'flex',
    marginLeft: '32px',
    gap: '8px',
    alignItems: 'center',
  },
  datePickerLabel: {
    ...TYPOGRAPHY.BODY3,
    color: COLORS.TEXT.SECONDARY_DEFAULT,
  },
  separator: {
    display: 'block',
    margin: '40px 0 32px 0',
    height: '1px',
    backgroundColor: COLORS.GREY_MEDIUM.DEFAULT,
  },
  notificationsTitle: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  notificationContainer: {
    marginTop: '24px',
    display: 'flex',
    gap: '32px',
    alignItems: 'center',
    ...TYPOGRAPHY.BODY2,
  },
  timeContainer: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
    marginLeft: '32px',
  },
  recurringNotificationContainer: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    marginLeft: '32px',
  },
});
